<div class="contract-upload">
  <h3>📎 {{ titleText }}</h3>
  <p class="hint">{{ hintText }}</p>

  <div *ngIf="loading" class="loading-message">{{ loadingText }}</div>
  <div *ngIf="error" class="error-message">{{ error }}</div>

  <div class="files-list" *ngIf="!loading && files.length > 0">
    <div class="file-row" *ngFor="let file of files">
      <div class="file-info">
        <span class="file-name" (click)="downloadFile(file)">{{ file.fileName }}</span>
        <span class="file-category">{{ categoryLabel(file) }}</span>
      </div>
      <button type="button" class="btn-remove" (click)="deleteFile(file)">✕</button>
    </div>
  </div>

  <div *ngIf="!loading && files.length === 0" class="empty-state">
    <p>{{ emptyStateText }}</p>
  </div>

  <label class="upload-button">
    {{ uploading ? uploadingText : uploadButtonText }}
    <input type="file" (change)="onFileSelected($event)" [disabled]="uploading" hidden />
  </label>
</div>
